module.exports = __webpack_public_path__ + "img/4.d38ebd24.png";